import List from './list/СontactQAUnavailableRoleListInitialState'

const { Record } = require('immutable')

export default Record({
	list: List()
})